// import _ from "lodash";
import {
    SET_NAV,
    PROCESSING,
    FORM_PROCESSING,
    COMPLETED,
    AUTH_USER,
    UNAUTH_USER,
    LOAD_DATA,
    LOAD_FILTERED_DATA,
    DATA_ERROR,
    SET_MESSAGES,
    DB_TYPE,
    DB_LIST,
    RESIZE,
    LOADING_FILES,
    FILE_LOAD_FAILED,
    FILE_LOAD_SUCCESS,
    UPDATE_CHECKS,
    DELETE_FILE_SUCCESS,
    TOGGLE_DELETE
} from '../actions/types';

const NBI_UNAUTH = [{Name: "Home", Link: "/", Active: true},
                    {Name: "Sign In", Link: "/signin", Active: false},
                    {Name: "Sign Up", Link: "/signup", Active: false}];

const NBI_AUTH = [{Name: "Home", Link: "/", Active: true},
                    {Name: "Sign Out", Link: "/signout", Active: false}];

const updateData = (state,row) => {
    var { data, dbtype } = state;
    if (dbtype === 'test') {  }
    for (var i = 0; i < data.length; i ++){
        if (data[i].ID === row.ID) {
            data[i] = row;
            if (dbtype === 'test') {
                var { dblist } = state;
                data[i]['IdeaName'] = findIdeaName(row['IdeaID'],dblist);
            }
            break;
        }
    }
    return data;
}

const findIdeaName = (id, dblist) => {
    for (var i = 0; i < dblist.length; i++) {
        if (dblist[i]['value'] === id) { return dblist[i]['text']; }
    }
    return '';
}

const createFiles = (files) => {
    var newfiles = [];
    for (var i = 0; i < files.length; i++) {
        newfiles.push({id: files[i].ID,
                    type:  files[i].Type,
                    name:  files[i].Name,
                    size:  files[i].Size,
                    checked: false,
                    local: false,
                    data: [],
                    blob: {}
        });
    }
    return newfiles;
}

export default function(state = {}, action) {
    var files;
    switch (action.type) {
        case SET_NAV:
            var nbi = state.navbaritems;
            for (var i = 0; i < nbi.length; i++){
                if (nbi[i].Link === action.payload) {
                    nbi[i].Active = true;
                } else {
                    nbi[i].Active = false;
                }
            }
            return { ...state, navbaritems: nbi}
        case PROCESSING:
            return { ...state, loading: true};
        case FORM_PROCESSING:
            return { ...state, form_loading: true};
        case COMPLETED:
            if (action.payload) {
                var newdata = updateData(state, action.payload);
                return { ...state, data: newdata, loading: false, form_loading: false};
            } else {
                return { ...state, loading: false, form_loading: false};
            }
        case AUTH_USER:
            const username = localStorage.getItem('name');
            return { ...state, error: '', authenticated: true, name: username, navbaritems: NBI_AUTH, loading: false };
        case UNAUTH_USER:
            return { ...state, authenticated: false, name: '', navbaritems: NBI_UNAUTH, loading: false};
        case LOAD_DATA:
            return { ...state, data: action.payload, filtereddata: action.payload, loading: false };
        case LOAD_FILTERED_DATA:
            return { ...state, filtereddata: action.payload, loading: false };
        case DATA_ERROR:
            return { ...state};
        case SET_MESSAGES:
            return { ...state, messages: action.payload, loading: false };
        case DB_TYPE:
            return { ...state, dbtype: action.payload };
        case DB_LIST:
            return { ...state, dblist: action.payload, form_loading: false};
        case RESIZE:
            return { ...state, width: action.payload.width, height: action.payload.height};
        case LOADING_FILES:
            return { ...state, fileloading: true};
        case FILE_LOAD_FAILED:
            return { ...state, fileloading: false};
        case FILE_LOAD_SUCCESS:
            if (action.payload.constructor === Array){
                files = createFiles(action.payload);
            } else if (action.payload){
                if (state.files) {
                    files = [...state.files, action.payload];
                } else {
                    files = [action.payload];
                }
            } else {
                files = state.files;
            }
            return { ...state, fileloading: false, files: files};
        case UPDATE_CHECKS:
            files = state.files;
            files[action.payload].checked = !files[action.payload].checked
            return { ...state, files: files};
        case DELETE_FILE_SUCCESS:
            files = [];
            for (var j = 0; j < state.files.length; j++){
                if (!state.files[j].checked){
                    files.push(state.files[j]);
                }
            }
            return { ...state, files: files, fileloading: false,};
        case TOGGLE_DELETE:
            return { ...state, deleteenabled: action.payload};
        default:
            return state;
        }
}



// WEBPACK FOOTER //
// ./src/reducers/reducer_app.js